var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('router-view',{key:_vm.routeTabKey})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }